export class UserInfo {
    id: string;
    firstname = '';
    lastname = '';
    email = '';
    roleID = '';
    roleId = '';
    tenantId = '';
    password = '';
    username = '';
    facilityID: number = 0;
    facilityName = '';
    role = '';
    userID :number ;
    user_id :number ;
    isDisabledDelete = false;
    isDisabledEdit = false;
    success:boolean;
    group_name: string | null;
    group_id:any;
    is_main_group:number;
    tenant_id:number

}
export class newUserInfo {
    id: string;
    firstname = '';
    lastname = '';
    email = '';
    roleID = '';
    tenantId = '';
    password = '';
    username = '';
    facilityID: number = 0;
    facilityName = '';
    role = '';
    userID = '';
    isDisabledDelete = false;
    isDisabledEdit = false;

}
